module.exports = __webpack_public_path__ + "static/img/mode2-7.eb79f920.png";